/**
 * Cheelee Public API Docs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetCurrencyPairsRespResult } from './getCurrencyPairsRespResult';


export interface GetCurrencyPairsResp { 
    jsonrpc?: GetCurrencyPairsResp.JsonrpcEnum;
    id?: number;
    result?: GetCurrencyPairsRespResult;
}
export namespace GetCurrencyPairsResp {
    export type JsonrpcEnum = '2.0';
    export const JsonrpcEnum = {
        _20: '2.0' as JsonrpcEnum
    };
}


